var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 88,
    viewBox: "0 0 90 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H90V61.4356H0V0Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.984 12.7637H61.5365",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.984 16.2573H60.3802",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4622 61.5688V0.134277",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 0.269337,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9242 61.5688V0.134277",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 0.269337,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3862 61.5688V0.134277",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 0.269337,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3347 84.4188L39.5334 86.7812L41.5788 86.8313L41.1994 84.3301L39.3347 84.4188Z",
    fill: "#E49D75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6962 80.2061L19.7465 83.453L20.7164 84.4762L22.4373 81.634L20.6962 80.2061Z",
    fill: "#E49D75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1856 86.2491L39.1486 88L44.5101 87.967C44.5472 87.992 44.5202 87.1086 44.5202 87.1086L41.3298 86.2241L39.1856 86.2491Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6735 82.897L18.5846 84.4011L20.8612 87.6663L23.0121 87.681L22.9829 86.5782L22.1208 86.1917L21.3563 84.2715L19.6735 82.897Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2051 16.6357H51.6789V27.243H41.2051V16.6357Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2051 16.6357H51.6789V19.005H41.2051V16.6357Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1574 29.2615C29.7029 29.1399 31.645 29.1922 32.1648 28.9102C32.6846 28.6283 39.1002 23.7601 39.7457 23.0972C40.3912 22.4344 41.1894 21.8592 41.7664 21.1384C42.3434 20.4176 41.7855 22.4151 41.2815 22.8085C41.2231 23.3428 41.2085 24.4615 41.2085 24.4615C41.0751 24.4378 40.9382 24.4428 40.8069 24.4763C40.6755 24.5098 40.5526 24.571 40.4462 24.6559C40.0825 24.9447 34.822 31.2147 34.822 31.2147C34.822 31.2147 28.6118 29.3843 29.1574 29.2615Z",
    fill: "#E49D75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3919 47.9928C24.0664 49.2434 23.4388 57.9975 25.3686 62.3768C24.5311 65.5794 20.2776 80.5046 20.2776 80.5046L22.3926 82.3919L33.2953 65.6795C33.2953 65.6795 31.0254 47.397 24.3919 47.9928Z",
    fill: "#34BBC4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5236 47.4515C35.9648 48.6941 40.4731 64.9972 40.4731 64.9972L41.4925 84.8008L39.1597 84.9873L31.9133 65.0461C31.0287 64.0309 25.409 50.404 25.1564 48.6555C26.261 47.4663 35.0824 46.2077 35.5236 47.4515Z",
    fill: "#2DA2AA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4115 28.4712C28.2995 28.4712 33.3287 29.7059 34.274 31.6954C34.7937 32.7891 37.0737 46.1602 35.8075 48.2623C34.5412 50.3644 25.8163 50.2746 24.1144 48.6898C23.1569 47.8007 22.8481 28.4644 27.4115 28.4712Z",
    fill: "#2B45D4",
    fillOpacity: 0.04
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H90V8.22431H0V0Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17053 13.0415H18.1402",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2981 26.1953H28.2245V29.9812C27.5318 30.5394 26.2981 29.9812 26.2981 29.9812V26.1953Z",
    fill: "#E49D75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.834 22.7733C23.834 20.4142 25.4157 18.502 27.3679 18.502C29.3201 18.502 30.9008 20.4142 30.9008 22.7733C30.9008 25.1323 29.319 27.0457 27.3679 27.0457C25.4169 27.0457 23.834 25.1323 23.834 22.7733Z",
    fill: "#E49D75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9426 17.7995C28.0741 17.7734 29.5122 18.5021 29.5122 19.008C29.5122 19.8834 28.1718 21.8685 27.1738 22.6825C27.4533 23.3362 27.7093 23.7682 27.7093 24.323C27.7093 24.8778 26.8572 27.0516 26.8572 28.5295C26.8572 29.6892 27.1132 30.4782 27.1132 31.44C27.1132 34.0674 25.4203 35.6579 22.9719 35.6579C20.5235 35.6579 18.8789 32.9691 18.8688 30.7863C18.8565 28.11 21.7876 24.8255 22.4982 22.8075C23.0965 21.1045 24.2292 17.7995 26.9426 17.7995Z",
    fill: "#FFDD00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1947 22.993C26.1947 22.8158 26.2466 22.6426 26.3439 22.4952C26.4411 22.3479 26.5793 22.233 26.741 22.1653C26.9028 22.0975 27.0807 22.0798 27.2523 22.1145C27.4239 22.1491 27.5816 22.2346 27.7052 22.36C27.8289 22.4854 27.9131 22.6451 27.9471 22.819C27.9811 22.9928 27.9634 23.173 27.8963 23.3367C27.8291 23.5003 27.7156 23.6402 27.57 23.7385C27.4243 23.8368 27.2532 23.8891 27.0782 23.8889C26.9621 23.8889 26.8471 23.8657 26.7398 23.8207C26.6326 23.7757 26.5351 23.7097 26.4531 23.6265C26.371 23.5432 26.306 23.4445 26.2616 23.3358C26.2173 23.2271 26.1946 23.1106 26.1947 22.993Z",
    fill: "#E49D75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7111 35.7396C36.7034 35.9784 40.7684 36.6685 41.5486 36.4217C42.3288 36.175 50.3666 28.4123 50.993 27.8382C51.6194 27.264 52.8767 26.4512 53.0283 25.4575C53.1798 24.4639 53.0283 23.6135 51.6655 23.1155C51.6913 23.7567 51.716 24.7572 51.689 24.6082C51.4589 23.8352 51.432 22.9586 51.0155 22.9688C50.791 23.6919 51.1075 25.055 50.5552 25.968C49.9209 26.666 41.4969 32.2641 40.6123 32.5472C39.4583 32.5472 36.4991 31.524 36.4991 31.524C36.4991 31.524 34.7198 35.5009 35.7111 35.7396Z",
    fill: "#E49D75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1134 31.7297C29.8004 28.8078 35.8277 30.3529 36.8414 31.1726C37.1961 32.2856 36.6382 35.5871 35.7525 36.1999C34.4222 36.3955 28.3815 34.8379 29.1134 31.7297Z",
    fill: "#2B45D4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17053 19.2617H14.723",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17053 29.9468H9.89018",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17053 33.9785H14.723",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17053 37.4722H13.5667",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2639 12.5449H85.2336",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2639 16.4214H81.0305",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2639 20.5444H84.3826",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2639 24.2964H77.876",
    stroke: "white",
    strokeWidth: 3.49599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5672 21.4191H44.5538L43.851 21.7955L43.7455 21.3771L44.6234 20.9019H45.0859V24.9674H44.5672V21.4191Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1576 20.9062V21.2689L47.4086 24.9718H46.8473L48.5884 21.3747V21.3621H46.625V20.9074L49.1576 20.9062Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultIcon);
export default __webpack_public_path__ + "static/media/consultIcon.dfdcb54eac6f6c922cca28065a708da0.svg";
export { ForwardRef as ReactComponent };